import { render, staticRenderFns } from "./openBrowser.vue?vue&type=template&id=ab2d28f6&scoped=true&"
import script from "./openBrowser.vue?vue&type=script&lang=js&"
export * from "./openBrowser.vue?vue&type=script&lang=js&"
import style0 from "./openBrowser.vue?vue&type=style&index=0&id=ab2d28f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2d28f6",
  null
  
)

export default component.exports